import { DealNote } from 'app/models/dto/dealNote.model';

export class GetDealNotes {
	static readonly type = '[DealNote] GetDealNotes';
	constructor(public dealId: number) {}
}

export class AddDealNote {
	static readonly type = '[DealNote] Add';
	constructor(public dealNote: DealNote) {}
}

export class DeleteDealNote {
	static readonly type = '[DealNote] Delete';
	constructor(public dealNoteId: number) {}
}

export class UpdateDealNote {
	static readonly type = '[DealNote] Update';
	constructor(public dealNoteId: number, public content: string) {}
}
